import {
    GET_SUBCATEGORIES_MARKETPLACE_PRODUCTS,
    GET_CATEGORIES_MARKETPLACE_PRODUCTS,
    GET_COMPANIES_LIST_TYPE_DOCUMENT, 
    GET_ALL_MONETIZATION_TYPES,   
    GET_FUNCTIONALITIES,   
    GET_COMPANIES_BY_ID,
    GET_STATE_LOADING,
    GET_COMPANIES,
    GET_COMPANY_DEMO_TYPES,
} from "@/views/companies/store/types/types.js";

const getters = {
    [GET_SUBCATEGORIES_MARKETPLACE_PRODUCTS]: state => state.subCategoriesProducts,
    [GET_CATEGORIES_MARKETPLACE_PRODUCTS]: state => state.categoriesProducts,
    [GET_COMPANIES_LIST_TYPE_DOCUMENT]: state => state.companyTypeId,
    [GET_ALL_MONETIZATION_TYPES]: state => state.monetizationTypes,
    [GET_FUNCTIONALITIES]: state => state.functionalities,
    [GET_COMPANIES_BY_ID]: state => state.companyById,
    [GET_STATE_LOADING]: state => state.loading,
    [GET_COMPANIES]: state => state.companies,
    [GET_COMPANY_DEMO_TYPES]: state => state.companyDemoTypes,
}

export default getters;